/** 积分包列表 */
export const CREDITS_PACKAGES = [
  {
    id: '1',
    credits: 50,
    price: 25,
    sku: 'point_50',
  },
  {
    id: '2',
    credits: 100,
    price: 50,
    sku: 'point_100',
  },
  {
    id: '3',
    credits: 200,
    price: 100,
    sku: 'point_200',
  },
  {
    id: '4',
    credits: 500,
    price: 250,
    sku: 'point_500',
  },
]